import React from 'react'
import './payment.scss'
import { PaymentUploadDocument } from './upload-document'
import { PaymentSubmittedSuccessful } from './submit-successful'
import { PaymentSummary } from './summary'
import { ContactUsModal } from '../../lib/components/ContactUsModal'
import { PaymentPresenterProps } from '../../lib/types'

const PaymentPresenter = ({
  handlePrintPaymentSummary,
  opportunity,
  paymentPage,
  handleViewSummary,
  investmentData,
  showContactUsModal,
  handleShowContactUsModal,
  handleFilePreview,
}: PaymentPresenterProps) => {
  return (
    <>
      {paymentPage === 'upload-document' && <PaymentUploadDocument opportunity={opportunity} />}
      {paymentPage === 'submitted-successful' && (
        <PaymentSubmittedSuccessful
          handleViewSummary={handleViewSummary}
          opportunity={opportunity}
        />
      )}
      {paymentPage === 'payment-summary' && (
        <PaymentSummary
          handlePrintPaymentSummary={handlePrintPaymentSummary}
          opportunity={opportunity}
          investmentData={investmentData}
          handleShowContactUsModal={handleShowContactUsModal}
          handleFilePreview={handleFilePreview}
        />
      )}
      {showContactUsModal ? (
        <ContactUsModal
          active={true}
          subject={'Inquiry'}
          handleOnClose={handleShowContactUsModal}
        />
      ) : null}
    </>
  )
}

export { PaymentPresenter }
